import {arrayOf, number, oneOfType, string} from "prop-types"

const strOrNum = oneOfType([string, number])
export default oneOfType([strOrNum, arrayOf(strOrNum)])
